import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=7f2522e0"
import script from "./GroupSetting.vue?vue&type=script&lang=js"
export * from "./GroupSetting.vue?vue&type=script&lang=js"
import style0 from "./GroupSetting.vue?vue&type=style&index=0&id=7f2522e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports